import { render, staticRenderFns } from "./withdraw_status.vue?vue&type=template&id=21334a6c&scoped=true&"
import script from "./withdraw_status.vue?vue&type=script&lang=js&"
export * from "./withdraw_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21334a6c",
  null
  
)

export default component.exports